import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import OrdersMain from "./OrdersMain";
import "./Orders.css";

const Orders: React.FC = () => {
  return (
    <div className="orders">
      <Sidebar activeTab="Orders" />
      <OrdersMain />
    </div>
  );
};

export default Orders;
